import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ClubReducer } from './reducer';
import { ClubEffects } from './effect';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('Club', ClubReducer),
    EffectsModule.forFeature([ClubEffects])
  ],
  exports: [StoreModule, EffectsModule],
  providers: []
})
export class ClubStoreModule {}
